module.exports = __webpack_public_path__ + "img/SC4-Debt.9ad22a76.png";